import { render, staticRenderFns } from "./CommunitySuggest.vue?vue&type=template&id=65715a2f"
import script from "./CommunitySuggest.vue?vue&type=script&lang=js"
export * from "./CommunitySuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports